var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-row',_vm._l((_vm.charts),function(x){return _c('div',{key:x.index,staticClass:"col-md-3 mt-5"},[_c('b-card',{staticStyle:{"cursor":"pointer"},attrs:{"img-src":'/media/Charts/' + x.index + '.jpg',"img-alt":"Image","img-top":"","title":x.name},on:{"click":function($event){return _vm.save(x)}}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }